import { render, staticRenderFns } from "./TaxInvoiceNiks.vue?vue&type=template&id=58905693&scoped=true&"
import script from "./TaxInvoiceNiks.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceNiks.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=58905693&scoped=true&lang=css&"
import style1 from "./TaxInvoiceNiks.vue?vue&type=style&index=1&id=58905693&scoped=true&lang=scss&"
import style2 from "./TaxInvoiceNiks.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58905693",
  null
  
)

export default component.exports